import Vue from 'vue'
import Router from 'vue-router'
import mainBasic from './main_basic'
import store from '../store/'

Vue.use(Router)

const routes = [
    ...mainBasic,
]

const router = new Router({
    routes,
    base: "/asset/",
    mode: 'hash',
    linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
    var activeTab = store.state.headTab.activeTab;
    if(!activeTab || activeTab =="") {
        if(to.name && to.name != "" && !to.meta.disableTab) {
            store.dispatch("addTab", {name:to.name,query:to.query});
            store.dispatch("addKeepAlive", to.name);
            store.dispatch("setActiveTab", to.name);
        }
    }
    next();
});


export default router


// WEBPACK FOOTER //
// ./src/router/index.js